<template>
  <div class="info-box" style="min-height:92.5vh">
    <div class="myinfo">
      <div class="bg1">
        <van-divider>基本信息</van-divider>
        <van-field name="uploader" label="头像" input-align="right">
          <template #input>
            <van-uploader :after-read="afterRead" v-model="fileList" :max-count="1"/>
          </template>
        </van-field>
        <van-field maxlength="20" v-model="record.fullName" label="账号名称" placeholder="请输入" input-align="right"/>
      </div>
      <!--导师详细信息-->
      <div class="bg1" v-if="record.teacherInfo">
        <van-divider>导师详细信息</van-divider>
        <teacher-edit ref="teacherEdit" :teacherInfo="record.teacherInfo" :facultyTypeOptions="facultyTypeOptions"/>
      </div>

      <!--学生详细信息-->
      <div class="bg1" v-if="record.studentInfo">
        <van-divider>学生详细信息</van-divider>
        <student-edit ref="studentEdit" :studentInfo="record.studentInfo" :facultyTypeOptions="facultyTypeOptions" />
      </div>

      <div style="height: 125px;background: #ffffff"></div>
      <van-button class="butstyle" type="info" @click="submitUser()">保存</van-button>
    </div>
  </div>
</template>

<script>
  import {customUploadFile} from "@/api/upload";
  import {getUserInfo, updateUser} from "@/api/my/my";
  import {FILE_DISPLAY_PREFIX} from "../../../api/upload";
  import StudentEdit from "./studentEdit";
  import TeacherEdit from "./teacherEdit";
  import {getDictByType} from '@/api/common'

  export default {
    name: "information",
    components: {StudentEdit, TeacherEdit},
    data() {
      return {
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        fileList: [
          {url: '@/assets/头像默认.png'},
        ],
        userHeader: '',
        record: {
          teacherInfo: {},
          studentInfo: {},
        },
        facultyTypeOptions: []
      }
    },
    created() {
      this.getDict()
      //获取用户信息
      getUserInfo().then(res => {
        if (res.code === 10000) {
          this.record = res.result
          if (res.result.userHeader) {
            this.fileList[0].url = this.fileDisplayPrefix + res.result.userHeader
          }
        }
      })
    },
    methods: {
      getDict() {
        // 查询字典，院系类型
        getDictByType('faculty_type').then(res => {
          if (res.code === 10000) {
            this.facultyTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      //文件上传
      afterRead(file) {
        customUploadFile(file).then(res => {
          if (res.code == 10000) {
            this.userHeader = res.result[0]
          }
        })

      },
      //提交
      submitUser() {
        // 校验学生必填项
        if (this.record.studentInfo) {
          const studentInfo = this.$refs.studentEdit.getInfo()
          if (!studentInfo.name) {
            this.$toast("姓名不能为空")
            return
          }
          if (!studentInfo.speciality) {
            this.$toast("专业方向不能为空")
            return
          }
          if (!studentInfo.mobileNum) {
            this.$toast("手机号不能为空")
            return
          }
          if (!studentInfo.email) {
            this.$toast("电子邮箱不能为空")
            return
          }
          if (!studentInfo.enrollmentYear) {
            this.$toast("入学年份不能为空")
            return
          }
          if (!studentInfo.resumePath) {
            this.$toast("简历不能为空")
            return
          }
          this.record.studentInfo = studentInfo
        }

        // 校验老师必填项
        if (this.record.teacherInfo) {
          const teacherInfo = this.$refs.teacherEdit.getInfo()
          if (!teacherInfo.name) {
            this.$toast("姓名不能为空")
            return
          }
          if (!teacherInfo.enrollmentDirection) {
            this.$toast("招生方向不能为空")
            return
          }
          if (!teacherInfo.category) {
            this.$toast("导师类别不能为空")
            return
          }
          // if (!teacherInfo.mobileNum) {
          //   this.$toast("手机号不能为空")
          //   return
          // }
          if (!teacherInfo.email) {
            this.$toast("电子邮箱不能为空")
            return
          }
          this.record.teacherInfo = teacherInfo
        }

        if (this.userHeader) {
          this.record.userHeader = this.userHeader
        }
        updateUser(this.record).then(res => {
          if (res.code === 10000) {
            this.$toast("操作成功")
            this.back()
          } else {
            this.$toast("操作失败")
          }
        })
      },
      back() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
  /deep/.van-divider {
    margin: 10px 0;
  }
  .butstyle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    background: #2C68E4;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    width: 92%;
    position: fixed;
    bottom: 70px;
    left: 15px;
  }

  .li-r {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
  }

  .info-box {
    background: #ffffff;
  }

  .myinfo {
    padding: 10px 0px;
    height: 80vh;
  }

  .myinfo ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    border-bottom: 1px solid #EEEEEE;
  }

  .myinfo ul li span {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #56555C;
  }

  /deep/ .van-uploader {
    display: flex;
    width: 40px;
    height: 40px;

  }

  /deep/ .van-uploader__preview-image {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    overflow: hidden;
  }

  /deep/ .van-uploader__preview {
    margin: 0;
  }

  .myinfo ul li i {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
  }

  .myinfo ul li i img {
    width: 9px;
    height: 15px;
  }

  /deep/ .van-uploader__upload {
    width: 40px;
    height: 40px;
    border-radius: 100px;
  }

  .myinfo ul li input {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    text-align: right;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #A1A0A6;
  }
  .van-field__label{
    display: flex;
    align-items: center;
  }
  @media screen and (min-width: 1024px) {
    .info-box{
      width: 1024px;
      margin:10px auto 0 auto;
      border-radius: 10px;
      background: none;
    }
    .butstyle{
      width: 40%;
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: 40px;
    }
    .bg1{
      background: #ffffff;
      margin-bottom: 10px;
      border-radius: 10px;
      overflow: hidden;
    }
    .van-divider{
      margin: 20px 0;
      font-size:16px;
      font-weight: bold;
      color: #000000;
    }
    .van-divider::after, .van-divider::before{
      display: block;
      -webkit-box-flex: inherit;
      -webkit-flex: inherit;
      flex: inherit;
  }
}
</style>
